<template>
  <div class="container-1">
    <!-- <div class="box"></div> -->
    <div class="center">
        <LoadingIndicator v-if="!error && loading" message="Getting Search Results..."/>
        <SystemMessage v-if="!loading && error" :message="message"/>
        <div v-if="!loading && !error" class="listings-heading">
            Search Results for '{{ search }}'
        </div>

        <div class="users-list" v-if="!loading && !error">
            <UserListItem v-for="(user, index) in users"
            :key="index"
            :user="user"/>
           
            
        </div>
         <!-- Pagination -->
          <div class="pagination-container">
              <div class="paginations" v-show="!error && (users.length >= 18)">
                  <div class="btn btn-default page-btn"
                  v-if="isLoadingMore" 
                    style="border:0px;color:var(--foreground)!important;"
                    disabled>{{pageButtonLabel}}</div>

                  <button
                  class="btn btn-default load-more page-btn"
                  @click="nextPage"
                  v-else>
                  {{pageButtonLabel}}
                </button>       
              </div>
            </div>
            <!-- Pagination -->  
    </div>
    <!-- <div class="box"></div> -->
  </div>
  
</template>

<script>
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import SystemMessage from '@/components/Utility/SystemMessage.vue';
import UserListItem from '@/components/Users/UserListItem.vue';
import { searchPublicUsersAsync } from '@/services/public/vacancyService'
export default {
    components:{
        UserListItem, LoadingIndicator, SystemMessage
    },
    data(){
        return{     
        showInitContent: true, //keep as true
        pageButtonLabel: "See More",
        isLoadingMore: false,
        pageNumber: 0,
        loading: true,
        error:false,
        users:[],
        message:"Unable to get search results. Try again later"
    }
    },
  computed: {
    search() {
      return this.$store.getters['search/getSearchTerm'];
    }
  },
  watch: {
    // Watch Vuex search getter to trigger API calls on Enter press
    search(newSearchTerm) {
      if (newSearchTerm) {
        this.pageNumber = 0;
        this.users = [];
        this.getPageAsync();
        
      }
    }
    

  },
  mounted(){
    if(this.search == ""){
      this.$router.push("/");
    }else{
      this.getPageAsync();
    }
  },
  // Runs whenever the user leaves this component/route
  unmounted() {
    this.$store.dispatch('search/updateSearchTerm', '');
  },
  methods:{
     nextPage(){
          this.getPageAsync();
    },
     async getPageAsync(){ 
        this.pageNumber+=1;
        if(this.pageNumber == 1){
          this.startLoading(); 
        }else{
          this.setButtonToLoadingMore();
        }
        setTimeout(async() => {
          try{
          let data = await searchPublicUsersAsync({search: this.search}, this.pageNumber);
          this.stopLoading();
          if(data.success == true){
            if(this.pageNumber == 1 && data.profiles.length == 0){
            this.setMessageOnZeroCount("No results found.");
            }else{
            data.profiles.forEach(profile => this.users.push(profile));
            
            this.setButtonToSuccessfullLoad();
            }
          }else{
           this.message = "Unable to get Search Results. Try again";
            if(this.pageNumber == 1){
               this.pageNumber-=1;
            this.error = true;
            }else{
              this.pageNumber-=1;
              this.setButtonToLoadingError();
            }
          }
        }catch(e){  
          this.message = "Unable to get Search Results. Try again";  
          this.stopLoading();
          if(this.pageNumber == 1){
            this.pageNumber-=1; //keep this
            this.error = true;
          }else{
            this.pageNumber-=1; //keep this
            this.setButtonToLoadingError();
          }
        }

        }, 4000);
      
        
    },
    startLoading(){
      this.loading = true;
      this.error = false;
    },
    stopLoading(){
      this.loading = false;
    },
    setMessageOnZeroCount(message){ //When no results were fo
          
            this.message = message;
            this.error = true;
    },
    setButtonToLoadingMore(){
        this.pageButtonLabel = "Getting More...",
        this.isLoadingMore = true;
    },
     setButtonToLoadingError(){
        this.pageButtonLabel = "Failed. Click again",
        this.isLoadingMore = false;
    },
    setButtonToSuccessfullLoad(){
        this.pageButtonLabel = "See More";
        this.isLoadingMore = false;
    }
   

  }
}
</script>
<style scoped>

.paginations{
    display:flex;
    justify-content: center;
    align-items: flex-start;
    grid-column:2/3;
    
}

.load-more{
  color:var(--foreground);
  background:var(--list-item);
  width:100%;
  border:0px;
  min-height:2rem;
}

.listings-heading{
  margin: 0.9rem 0rem;
  color: var(--page-header);
  font-family:var(--page-header-font);
  font-size: 1rem;
}

.container-1{
    display:flex;
    margin-top:1rem;
}

.box{
    flex:1;
}

.center{
    flex:2;
     margin:0rem 0.8rem;
}

.users-list{
  display: grid;
  grid-template-columns:repeat(3, 1fr);
  column-gap:0.5rem;
}

.pagination-container{
  display: grid;
  grid-template-columns:repeat(3, 1fr);
  column-gap:0.5rem;
}

.page-btn{
  padding:1rem 0rem;
  border-radius:8px;
  text-transform:uppercase;
  letter-spacing:0.4rem;
  font-size:0.7rem;
  font-weight:bold;
}

@media (max-width: 768px) {

    .container-1{ 
        margin-top:1.2rem;
    }

    .box{
        display: none;
    }

    .center{
        margin:0rem 0.8rem;
    }
     .listings-heading{
      margin:0.4rem 0rem;
      color: var(--page-header); 
      font-size: 1rem;
      font-weight: bold;
       font-family:var(--heading-font2-regular);
    }

    .users-list{
      grid-template-columns:1fr;
      column-gap:0.5rem;
    }

    .pagination-container{  
      grid-template-columns:1fr
      
    }

    .paginations{
    
      grid-column:1/2;
      
  }
}

</style>